import Vue from 'vue';

const API_URL_PREFIX = '/api/v4/parent/subscriptions';

const getDefaultSubscriptionsState = () => ({
  subscriptions: {},
  subscriptionDetail: {
    invoices: {
      past: [],
      upcoming: {},
    },
  },
  outstandingSubscriptions: [],
  outstandingSubscriptionInvoices: {},
  paidSubscriptionInvoices: [],
  selectedInvoicesToPay: [],
});

export default {
  state: getDefaultSubscriptionsState(),
  actions: {
    async GET_OUTSTANDING_SUBSCRIPTIONS(context) {
      const request = {
        url: `${API_URL_PREFIX}/outstanding`
      };
      const mutation = 'UPDATE_OUTSTANDING_SUBSCRIPTIONS';
      const options = {
        request,
        mutation,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async GET_OUTSTANDING_SUBSCRIPTION_INVOICES(context, payload) {
      context.commit('UPDATE_OUTSTANDING_SUBSCRIPTION_INVOICES', {});

      const request = {
        url: `${API_URL_PREFIX}/outstanding/invoices`
      };
      const mutation = 'UPDATE_OUTSTANDING_SUBSCRIPTION_INVOICES';
      const options = {
        request,
        mutation,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async GET_SUBSCRIPTIONS_FROM_STRIPE(context, payload) {
      context.commit('UPDATE_SUBSCRIPTIONS', {});

      const request = {
        url: `${API_URL_PREFIX}/all`
      };
      const mutation = 'UPDATE_SUBSCRIPTIONS';
      const options = {
        request,
        mutation,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async GET_SUBSCRIPTION_DETAIL_FROM_STRIPE(context, payload) {
      const request = {
        url: `${API_URL_PREFIX}/all/detail`,
        parameters: payload
      };
      const mutation = 'UPDATE_SUBSCRIPTION_DETAIL';
      const options = {
        request,
        mutation,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async PAY_SELECTED_INVOICES_WITH_CARD(context, payload) {
      const request = {
        url: `${API_URL_PREFIX}/outstanding/pay`,
        parameters: payload
      };
      const mutation = 'UPDATE_SELECTED_OUTSTANDING_INVOICES_AFTER_PAYMENT';
      const message = { success: 'Payment Successful!', icon: '🎉' };

      const options = {
        request,
        mutation,
        message,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },

    async UPDATE_DEFAULT_CARD_AT_CLIENT_STRIPE(context, payload) {
      const request = {
        url: `${API_URL_PREFIX}/outstanding/update-default-card-client`,
        parameters: payload
      };

      const options = {
        request,
        globalLoading: true,
      };

      return await context.dispatch('MAKE_POST_REQUEST', options);
    },
  },

  mutations: {
    UPDATE_OUTSTANDING_SUBSCRIPTIONS(state, payload) {
      state.outstandingSubscriptions = payload;
    },

    UPDATE_OUTSTANDING_SUBSCRIPTION_INVOICES(state, payload) {
      state.outstandingSubscriptionInvoices = payload;
    },

    UPDATED_SELECTED_OUTSTANDING_INVOICES(state, payload) {
      state.selectedInvoicesToPay = payload;
    },

    UPDATE_SELECTED_OUTSTANDING_INVOICES_AFTER_PAYMENT(state, payload) {
      if (payload.successful) {
        state.paidSubscriptionInvoices.push(payload.successful);
        state.selectedInvoicesToPay = [];
      } else {
        state.paidSubscriptionInvoices = [];
      }
    },

    UPDATE_SUBSCRIPTIONS(state, payload) {
      state.subscriptions = payload;
    },

    UPDATE_SUBSCRIPTION_DETAIL(state, payload) {
      state.subscriptionDetail = payload;
    },

    RESET_SUBSCRIPTIONS_STATE(state) {
      Object.assign(state, getDefaultSubscriptionsState());
    },
  },

  getters: {
    outstandingSubscriptions(state) {
      return state.outstandingSubscriptions;
    },
    outstandingSubscriptionInvoices(state) {
      return state.outstandingSubscriptionInvoices;
    },
    selectedInvoicesToPay(state) {
      return state.selectedInvoicesToPay;
    },
    paidSubscriptionInvoices(state) {
      return state.paidSubscriptionInvoices;
    },
    subscriptions(state) {
      return state.subscriptions;
    },
    subscriptionDetail(state) {
      return state.subscriptionDetail;
    },
  },
};
